export default __webpack_public_path__ + "static/media/development.48c730d7.svg";